var React = require('react');

function Folding (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n    ")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},React.createElement("polyline",{"className":"cls-1","points":".3 .85 55.29 19.99 55.29 20.23 1.22 45.9 1.22 46.59 55.29 56.02 55.29 56.13 1.22 66.8 1.22 67 56.18 67"}))]);
}

Folding.defaultProps = {"id":"Capa_2","data-name":"Capa 2","viewBox":"0 0 56.19 67.9"};

module.exports = Folding;

Folding.default = Folding;
